// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#page {
    background-color: #f4f4f4;
}

@media (min-width: 992px) {
    .w-lg-50 {
        width: 50%;
        height: 100vh;
    }
}

#login_root .background {
    background-size: cover;
}

#login_root>div>div {
    justify-content: center;
}

@media (min-width: 992px) {
    .h-lg-100px {
        height: 100px !important;
        width: fit-content;
    }

    .h-80px {
        height: 80px !important;
        width: fit-content;
    }
}

#page img {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
}

.loginUI {
    display: flex;
    flex-direction: column;
    padding: 2vh;
    min-width: 40vh;
    min-height: 50vh;
}

.loginUI_title {
    font-size: 3vh;
}

.loginUI_title {
    font-weight: bold;
    font-size: 3vh;
    color: #3d3d3d;
    margin-bottom: 1vh;
}

.w-lg-500px{
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}

.form-group input{
    height: 50px;
}

.submit,
.submit:hover,
.submit:active {
    background-color: #2489a5 !important;
    border: 0px !important;
    color: white !important;
    height: 50px;
}

.error{
    text-align: left;
    color: red;
    font-size: 12px;
}

.back a{
    color: #2489a5 !important;
    text-decoration: none;
}

.send-email{
    text-align: left !important;
    font-size: 15px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/CreateUser/CreateUserPage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B","sourcesContent":["#page {\n    background-color: #f4f4f4;\n}\n\n@media (min-width: 992px) {\n    .w-lg-50 {\n        width: 50%;\n        height: 100vh;\n    }\n}\n\n#login_root .background {\n    background-size: cover;\n}\n\n#login_root>div>div {\n    justify-content: center;\n}\n\n@media (min-width: 992px) {\n    .h-lg-100px {\n        height: 100px !important;\n        width: fit-content;\n    }\n\n    .h-80px {\n        height: 80px !important;\n        width: fit-content;\n    }\n}\n\n#page img {\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.loginUI {\n    display: flex;\n    flex-direction: column;\n    padding: 2vh;\n    min-width: 40vh;\n    min-height: 50vh;\n}\n\n.loginUI_title {\n    font-size: 3vh;\n}\n\n.loginUI_title {\n    font-weight: bold;\n    font-size: 3vh;\n    color: #3d3d3d;\n    margin-bottom: 1vh;\n}\n\n.w-lg-500px{\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.form-group input{\n    height: 50px;\n}\n\n.submit,\n.submit:hover,\n.submit:active {\n    background-color: #2489a5 !important;\n    border: 0px !important;\n    color: white !important;\n    height: 50px;\n}\n\n.error{\n    text-align: left;\n    color: red;\n    font-size: 12px;\n}\n\n.back a{\n    color: #2489a5 !important;\n    text-decoration: none;\n}\n\n.send-email{\n    text-align: left !important;\n    font-size: 15px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
